import React, { useMemo } from "react";
import { intl } from "dmsbasereact";
import { Alert } from "@mui/material";

const formatTimestamp = (date) => (date ? date.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : null);

export const DmsHelpCenterOfflineBanner = ({ isOffline, isStale, lastUpdated }) => {
  const message = useMemo(() => {
    const timestamp = formatTimestamp(lastUpdated);

    if (isOffline && isStale) {
      return intl
        .get("helpCenter.offlineStale", {
          timestamp: timestamp || "desconhecida",
        })
        .d(
          "Sem conexão. Mostrando conteúdo offline desatualizado (última sincronização: {timestamp})."
        );
    }
    if (isOffline) {
      return intl
        .get("helpCenter.offlineFresh", {
          timestamp: timestamp || "",
        })
        .d(
          "Sem conexão. Exibindo última versão disponível."
        );
    }
    if (isStale) {
      return intl
        .get("helpCenter.cacheStale", {
          timestamp: timestamp || "",
        })
        .d(
          "Conteúdo pode estar desatualizado."
        );
    }
    return null;
  }, [isOffline, isStale, lastUpdated]);

  if (!message) {
    return null;
  }

  return (
    <Alert severity={isOffline ? "warning" : "info"} sx={{ mb: 2 }}>
      {message}
    </Alert>
  );
};
